let _isMobile: boolean = false;
let _iOS: boolean = false;
let _chrome: boolean = false;

function setIsMobile(): void {
    if (process.env.BROWSER) {
        _isMobile = window.innerWidth <= 840;
        _iOS = (/iphone|ipod|ipad/i).test(
            window.navigator.userAgent) && !window.MSStream;
        _chrome = (/Chrome/).test(window.navigator.userAgent);
    }
}
if (process.env.BROWSER) {
    window.addEventListener('resize', function(): void {
        setIsMobile();
    });
    setIsMobile();
}

export function isMobile(): boolean {
    return _isMobile;
}

export function iOS(): boolean {
    return _iOS;
}

export function isChrome(): boolean {
    return _chrome;
}
